import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

@Component({
  selector: 'app-intake-form-select',
  standalone: true,
  imports: [MatRadioButton, MatRadioGroup, ReactiveFormsModule],
  templateUrl: './intake-form-select.component.html',
  styleUrl: './intake-form-select.component.scss',
})
export class IntakeFormSelectComponent {
  // Label: value
  // If string[], label is value
  @Input()
  options: { readonly [k: string]: string } | string[];
  @Input('formControlInstance')
  formControl: FormControl;
  @Input()
  onKeydownEnter: () => void = () => {};

  select(newValue: string) {
    this.formControl.setValue(newValue);
  }

  optionsEntries() {
    if (Array.isArray(this.options)) {
      const result = [];
      for (const option of this.options) {
        result.push([option, option]);
      }
      return result;
    } else {
      return Object.entries(this.options);
    }
  }
}
